import { BoxProps, TextProps } from '@jfs/ui-new'
const shadow = {
  shadowColor: '#000',
  shadowOffset: {
    width: 0,
    height: 1,
  },
  shadowOpacity: 0.22,
  shadowRadius: 2.22,
  elevation: 3,
}

const styles = {
  contantViewStyle: {
    bg: 'WHITE',
    padding: 16,
    borderRadius: 5,
    ...shadow,
    zIndex: 10,
    h: '100%',
  } as BoxProps,
  textStyle: {
    fontSize: 'FONT_SIZE_MEDIUM',
  } as TextProps,
}

export default styles
